import { frontendURL } from '../../../helper/URLHelper';
import CrmView from './CrmView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_index',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: CrmView,
  },
];
